/**
 * src/admin-ui/src/pages/ApiKeys.styles.ts
 *
 * Responsive API-key list styles.
 */

import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const KeyValue = styled(Typography)({
  overflowWrap: "anywhere",
  fontFamily: "monospace",
});
